var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.265625,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#627EEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2641 3L12.1494 3.38968V14.6964L12.2641 14.8108L17.5125 11.7085L12.2641 3Z",
    fill: "#C0CCF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2641 3L7.01562 11.7085L12.2641 14.8108V9.32286V3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2639 15.8045L12.1992 15.8833V19.9109L12.2639 20.0997L17.5154 12.7038L12.2639 15.8045Z",
    fill: "#C0CCF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2641 20.0997V15.8045L7.01562 12.7038L12.2641 20.0997Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2637 14.8109L17.512 11.7085L12.2637 9.32291V14.8109Z",
    fill: "#8198EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01562 11.7085L12.2641 14.8109V9.32291L7.01562 11.7085Z",
    fill: "#C0CCF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.6ce79d391c712a6c5229c8e28c219b9b.svg";
export { ForwardRef as ReactComponent };